/** sessionStorage key scoped by teamId, matching the message-cache and threadId keys. */
function getConversationIdKey(teamId: string) {
  return `optibot-conversationId-${teamId}`;
}

/**
 * Stable id for the current thread, sent on every turn so traces no longer have to
 * reconstruct conversations by walking each account's turns in time order.
 */
export function getOrCreateConversationId(teamId: string): string {
  try {
    const existing = sessionStorage.getItem(getConversationIdKey(teamId));
    if (existing) return existing;
    const minted = crypto.randomUUID();
    sessionStorage.setItem(getConversationIdKey(teamId), minted);
    return minted;
  } catch {
    // sessionStorage unavailable — the backend mints a fallback per turn.
    return crypto.randomUUID();
  }
}

/** Start a new thread. */
export function resetConversationId(teamId: string) {
  try {
    sessionStorage.removeItem(getConversationIdKey(teamId));
  } catch {
    // sessionStorage unavailable — nothing cached to clear.
  }
}

/** Adopt a thread loaded from history, so resuming it keeps one identity. */
export function setConversationId(teamId: string, conversationId: string) {
  try {
    sessionStorage.setItem(getConversationIdKey(teamId), conversationId);
  } catch {
    // sessionStorage unavailable — nothing to persist.
  }
}
